<template>
  <div class="d-flex mr-1" :class="{ 'flex-row-reverse': reverse }">
    <user-avatar v-for="user in usersComputed" :key="user.id" :user="user" :size="size" :style="{ 'margin-left': `${-size / 4}px` }" />
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    users: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 48
    },
    reverse: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    usersComputed() {
      return this.reverse ? this.users.slice().reverse() : this.users
    }
  }
}
</script>
